import React, { useState, useMemo } from 'react';
import axios from 'axios';
import { API_BASE } from '../api';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Calcular posiciones/tamaños de partículas una sola vez para evitar saltos al escribir
  const particulas = useMemo(() => Array.from({ length: 15 }, () => ({
    size: Math.random() * 80 + 20,
    opacity: Math.random() * 0.1 + 0.05,
    left: Math.random() * 100,
    top: Math.random() * 100,
    duration: Math.random() * 10 + 10,
    delay: Math.random() * 5
  })), []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const apiUrl = `${API_BASE}/api/auth/login`;
      const res = await axios.post(apiUrl, { email, password });
      onLogin(res.data.token, res.data.role);
    } catch (err) {
      if (err.response) {
        if (err.response.status === 404) setError('✗ Usuario no encontrado');
        else if (err.response.status === 401) setError('✗ Credenciales incorrectas');
        else setError('✗ ' + (err.response.data?.error || 'Error en el servidor'));
      } else {
        setError('✗ Error de conexión');
      }
    }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'linear-gradient(135deg,#667eea 0%,#764ba2 100%)',padding:'20px',position:'relative',overflow:'hidden'}}>
      {/* Partículas flotantes de fondo */}
      <div style={{position:'absolute',width:'100%',height:'100%',overflow:'hidden',pointerEvents:'none'}}>
        {particulas.map((p, i) => (
          <div key={i} style={{
            position:'absolute',
            width:`${p.size}px`,
            height:`${p.size}px`,
            borderRadius:'50%',
            background:`rgba(255,255,255,${p.opacity})`,
            left:`${p.left}%`,
            top:`${p.top}%`,
            animation:`floatParticle ${p.duration}s ease-in-out infinite`,
            animationDelay:`${p.delay}s`
          }}/>
        ))}
      </div>
<style>{`
@keyframes slideUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes floatParticle{0%,100%{transform:translate(0,0) scale(1)}25%{transform:translate(20px,-30px) scale(1.1)}50%{transform:translate(-15px,-50px) scale(0.9)}75%{transform:translate(25px,-20px) scale(1.05)}}
@keyframes glow{0%,100%{box-shadow:0 0 20px rgba(102,126,234,0.3),0 0 40px rgba(102,126,234,0.2)}50%{box-shadow:0 0 30px rgba(102,126,234,0.5),0 0 60px rgba(102,126,234,0.3)}}
@keyframes shimmer{0%{background-position:200% center}100%{background-position:-200% center}}
@keyframes bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}
.login-input{width:100%;padding:16px 20px 16px 50px;border:2px solid #e2e8f0;border-radius:12px;font-size:1rem;font-family:Inter,sans-serif;outline:0;background:#f8fafc;transition:all .3s}
.login-input:focus{border-color:#667eea;background:#fff;box-shadow:0 0 0 4px rgba(102,126,234,.1);transform:scale(1.01)}
.login-btn{width:100%;padding:18px;border:4px solid transparent;background:linear-gradient(white,white) padding-box,linear-gradient(135deg,#FF3B8F 0%,#A855F7 20%,#3B82F6 40%,#06B6D4 60%,#10B981 80%,#FB923C 100%) border-box;background-size:auto,300% 300%;color:#1e293b;border-radius:12px;font-size:1.1rem;font-weight:800;cursor:pointer;transition:all .4s;box-shadow:0 6px 20px rgba(0,0,0,0.1),0 3px 10px rgba(0,0,0,0.06);position:relative;overflow:visible;animation:loginRainbow 8s linear infinite}
@keyframes loginRainbow{0%{background-position:0% 50%,0% 50%}50%{background-position:0% 50%,100% 50%}100%{background-position:0% 50%,0% 50%}}
@keyframes loginOrb{0%,100%{transform:translate(0,0) scale(1);opacity:.3}50%{transform:translate(20px,-15px) scale(1.15);opacity:.5}}
.login-btn::before{content:'';position:absolute;width:100px;height:100px;background:radial-gradient(circle,rgba(255,59,143,0.2) 0%,rgba(168,85,247,0.15) 40%,transparent 70%);border-radius:50%;top:50%;left:-20px;transform:translateY(-50%);animation:loginOrb 7s ease-in-out infinite;filter:blur(30px);pointer-events:none;z-index:-1}
.login-btn::after{content:'';position:absolute;width:90px;height:90px;background:radial-gradient(circle,rgba(6,182,212,0.2) 0%,rgba(16,185,129,0.15) 40%,transparent 70%);border-radius:50%;top:50%;right:-20px;transform:translateY(-50%);animation:loginOrb 9s ease-in-out infinite reverse;filter:blur(35px);pointer-events:none;z-index:-1}
.login-btn:hover:not(:disabled){transform:translateY(-4px) scale(1.02);box-shadow:0 10px 35px rgba(0,0,0,0.12),0 5px 18px rgba(0,0,0,0.08),0 0 60px rgba(168,85,247,0.2);animation:loginRainbow 4s linear infinite}
.login-btn:active:not(:disabled){transform:translateY(-2px) scale(0.98);box-shadow:0 5px 18px rgba(0,0,0,0.1),0 2px 8px rgba(0,0,0,0.06)}
.login-btn:disabled{background:linear-gradient(#f1f5f9,#f1f5f9) padding-box;border:3px solid #e2e8f0;color:#94a3b8;opacity:.7;cursor:not-allowed;animation:none;box-shadow:0 2px 8px rgba(0,0,0,.05)}
.login-btn:disabled::before,.login-btn:disabled::after{display:none}
.input-icon{position:absolute;left:18px;top:50%;transform:translateY(-50%);font-size:1.2rem;animation:bounce 2s ease-in-out infinite}
@media (max-width:600px){.login-container{padding:32px 24px!important}}
`}</style>
<div className="login-container" style={{maxWidth:'440px',width:'100%',background:'rgba(255,255,255,0.95)',backdropFilter:'blur(20px)',borderRadius:'24px',padding:'48px 40px',boxShadow:'0 20px 60px rgba(0,0,0,.3), 0 0 100px rgba(102,126,234,0.2)',animation:'slideUp .6s cubic-bezier(.16,1,.3,1)',position:'relative',border:'1px solid rgba(255,255,255,0.3)'}}>
<div style={{textAlign:'center',marginBottom:'40px'}}>
<div style={{display:'inline-block',animation:'float 3s ease-in-out infinite'}}>
<img src={process.env.REACT_APP_ICON_PATH||'/icono-app.png'} alt="Logo" style={{height:'80px',width:'auto',marginBottom:'20px',borderRadius:'16px',boxShadow:'0 8px 24px rgba(102,126,234,.2)'}} draggable={false}/>
</div>
<h1 style={{fontSize:'2rem',fontWeight:700,color:'#1e293b',margin:'0 0 8px',fontFamily:'Poppins,sans-serif'}}>Bienvenido</h1>
<p style={{fontSize:'1rem',color:'#64748b',margin:0}}>{process.env.REACT_APP_CLINIC_NAME||'Sistema de Fichaje'}</p>
</div>
<form onSubmit={handleLogin}>
<div style={{marginBottom:'24px',position:'relative'}}>
<span className="input-icon">👤</span>
<input className="login-input" type="email" placeholder="Correo electrónico" value={email} onChange={e=>setEmail(e.target.value)} required autoComplete="username"/>
</div>
<div style={{marginBottom:'28px',position:'relative'}}>
<span className="input-icon">🔒</span>
<input className="login-input" type="password" placeholder="Contraseña" value={password} onChange={e=>setPassword(e.target.value)} required autoComplete="current-password"/>
</div>
{error&&<div style={{padding:'14px 16px',background:'linear-gradient(135deg,#fee2e2 0%,#fecaca 100%)',color:'#991b1b',borderRadius:'12px',marginBottom:'24px',fontSize:'.95rem',fontWeight:500,border:'2px solid #ef4444',animation:'slideUp .3s ease-out',textAlign:'center'}}>{error}</div>}
<button type="submit" className="login-btn" disabled={loading}>
{loading?<span style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'10px'}}><span style={{display:'inline-block',width:'20px',height:'20px',border:'3px solid rgba(255,255,255,.3)',borderRadius:'50%',borderTopColor:'#fff',animation:'spin .8s linear infinite'}}/>Iniciando sesión...</span>:<span style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}><span style={{fontSize:'1.2rem'}}>🔑</span>Iniciar Sesión</span>}
</button>
</form>
<div style={{marginTop:'32px',padding:'16px',background:'#f8fafc',borderRadius:'12px',textAlign:'center',fontSize:'.85rem',color:'#64748b'}}><span style={{fontSize:'1rem',marginRight:'6px'}}>🛡️</span>Tu información está protegida y segura</div>
</div>
</div>
  );
}

export default Login;
